import { type Variants } from "motion";
import { motion } from "motion/react";
import CircularText from "./CircularText";
import CircleIconAnimationButton from "../../components/ui/circle-icon-animation-button";

const Banner = () => {
  const text =
    "Expert Sign Service & Installation for Businesses, Stores, and Commercial Spaces";
  const words = text.split(" ");
  const container: Variants = {
    hidden: {},
    visible: {
      transition: {
        staggerChildren: 0.02,
      },
    },
  };

  const child: Variants = {
    hidden: {
      x: 80,
      opacity: 0,
    },
    visible: {
      x: 0,
      opacity: 1,
      transition: {
        duration: 0.35,
        ease: "easeOut",
      },
    },
  };

  return (
    <div className="relative mb-14  w-full min-h-screen flex justify-center items-center  bg-black">
      <div className="hidden md:flex absolute right-10 z-5 top-full ">
        <CircularText text="Let's Build Together " />
      </div>
      <div className="absolute bottom-0 left-0 inset-x-0 w-full h-60 bg-linear-to-t from-[#111212] z-4 to-transparent"></div>
      <video
        src="https://cdn.shopify.com/videos/c/o/v/ba8c7b9ac1434fcfb217c205ecd8f2fe.mp4"
        autoPlay
        loop
        muted
        playsInline
        className="absolute inset-0 w-full h-full object-cover opacity-60"
      />
      <div className="absolute inset-0 bg-black/20" />
      <div className="relative z-10 flex justify-center items-center w-full h-full px-5 sm:px-8 lg:px-12">
        <div className="w-full max-w-400 flex flex-col justify-center py-20">
          <p className="text-xs font-bold uppercase tracking-widest mb-4 sm:mb-6 text-white text-center lg:text-left">
            <span className="text-[#4991b8]">#1</span> Choice for Professional
            Sign Installation in California
          </p>
          <div className="relative w-fit">
            <motion.h1
              variants={container}
              initial="hidden"
              animate="visible"
              className="relative wrap-break-word z-10 text-3xl sm:text-4xl lg:text-5xl font-semibold max-w-3xl leading-tight text-white mb-6 sm:mb-10 text-center lg:text-left flex flex-wrap"
            >
              {words.map((word, index) => (
                <motion.p
                  key={`words-items-item-${index}`}
                  className="inline-flex gap-0.1"
                >
                  {word.split("").map((letter, inx) => (
                    <motion.span
                      variants={child}
                      key={`words-items-item-${index}-${inx}`}
                    >
                      {letter}
                    </motion.span>
                  ))}
                  &nbsp;
                </motion.p>
              ))}
            </motion.h1>
          </div>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
            <motion.div
              initial={{ x: -100, opacity: 0, scale: 0.96 }}
              animate={{ x: 0, opacity: 1 }}
              transition={{
                delay: 0.25,
                duration: 0.6,
                ease: "easeOut",
              }}
              className="flex flex-col gap-7 text-center lg:text-left"
            >
              <p className="text-white/90 font-light max-w-lg mx-auto lg:mx-0">
                We provide expert sign installation, maintenance, and repair
                services for businesses. From storefront signage to large
                commercial displays, we ensure every sign is installed safely,
                professionally, and built to last.
              </p>
              <CircleIconAnimationButton className="mx-auto lg:mx-0 w-fit">
                Connect Us
              </CircleIconAnimationButton>
            </motion.div>
            <motion.div
              initial={{ x: 100, opacity: 0, scale: 0.96 }}
              animate={{ x: 0, opacity: 1 }}
              transition={{
                delay: 0.35,
                duration: 0.6,
                ease: "easeOut",
              }}
              className="w-full flex relative justify-end items-end"
            >
              <div className="relative  rounded-2xl p-6 backdrop-blur-2xl text-white w-full max-w-md mx-auto lg:mx-0 overflow-hidden">
                <div className="absolute inset-0 opacity-[0.03]  pointer-events-none">
                  <svg
                    className="w-full h-full"
                    viewBox="0 0 100 100"
                    preserveAspectRatio="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <filter id="noiseFilter">
                      <feTurbulence
                        type="fractalNoise"
                        baseFrequency="0.8"
                        numOctaves="4"
                        stitchTiles="stitch"
                      />
                    </filter>
                    <rect
                      width="100%"
                      height="100%"
                      filter="url(#noiseFilter)"
                    />
                  </svg>
                </div>
                <div className="relative z-10">
                  <div className="flex gap-1 mb-3 justify-center lg:justify-start">
                    {[...Array(5)].map((_, i) => (
                      <svg
                        key={i}
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        fill="#4991b8"
                        className="w-5 h-5"
                      >
                        <path d="M12 2l3.09 6.26L22 9.27l-5 4.87L18.18 21 12 17.77 5.82 21 7 14.14 2 9.27l6.91-1.01L12 2z" />
                      </svg>
                    ))}
                  </div>
                  <p className="text-white/90 mb-4 leading-relaxed text-sm sm:text-base text-center lg:text-left">
                    " The team did an amazing job installing our storefront
                    sign. The process was smooth, professional, and the final
                    result looks incredible. Highly recommended! "
                  </p>
                  <p className="text-[#4991b8] text-xs font-semibold text-center lg:text-left">
                    - <em>James Morison Leo , India</em>
                  </p>
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Banner;
